module.exports = __webpack_public_path__ + "static/replace-07010769b45347cf2ef961a484636f04.jpg";